// store/attendeeSlice.js
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Async thunk to fetch attendees for a webinar
export const fetchAttendees = createAsyncThunk(
  "attendees/fetchAttendees",
  async (webinarId, { rejectWithValue }) => {
    try {
      const access = localStorage.getItem("access"); // token stored from auth
      const response = await axios.get(
        `https://api-workshop.firststepoverseas.com/webinars/${webinarId}/attendees`,
        {
          headers: {
            Authorization: `JWT ${access}`,
          },
        }
      );

      const attendees = response.data.results || [];

      // 📌 Send attendees to Google Sheet
      await axios.get(
        "https://script.google.com/macros/s/AKfycbwv5854H-AcSmemBK-cU3EKGRwKilJWS2wo3QcCVOfbvTkX-rSjuo5OZB-Au3IBunw/exec?key=MYWEBINAR123",
        attendees
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data || { detail: "Failed to fetch attendees" }
      );
    }
  }
);

const attendeeSlice = createSlice({
  name: "attendees",
  initialState: {
    items: [],
    count: 0,
    loading: false,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAttendees.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchAttendees.fulfilled, (state, action) => {
        state.loading = false;
        state.items = action.payload.results || [];
        state.count = action.payload.count || 0;
      })
      .addCase(fetchAttendees.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.detail || "Unable to load attendees";
      });
  },
});

export default attendeeSlice.reducer;
